/*
 * Momentum-App: This is an automatically deployed file. Manual changes will be overwritten.
 * views/shopify-theme/momentum-utils.js
 *
 * This file contains utility methods for ONE shopify stores.
 * The file is automatically replicated to all ONE shopify stores as assets/momentum-utils.js
 * Changes made to this file after it has been deployed to a Shopify theme will be overwritten.
 * Any changes made within the Momentum app will be deployed automatically to all applicable
 * Shopify stores then next time the Momentum app is updated.
 * See issue #189 for more details: https://github.com/globalprotectioncorp/momentum-node-app/issues/189
 */

(function () {
    //default value, which will be overridden for on every page load
    var app_url = 'https://myone.onecondoms.com/';
    var queues = {};
    var last_hash_change = 0;
    var last_get_page = false;
    var qs_action = false;

    var myone = {
        data: {},
        ready: window.myone.ready,
        readyState: window.myone.readyState,
        setAppUrl: function (url) {
            app_url = url;
        },
        setAction: function (action) {
            qs_action = action;
        },
        getUrlVars: function () {
            var vars = [],
                hash;
            var hashes = window.location.href
                .slice(window.location.href.indexOf('?') + 1)
                .split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        },
        getParameterByName: function (name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) {
                return false;
            }
            if (!results[2]) {
                return false;
            }
            return myone.decodeURIComponent(results[2]);
        },
        createCookie: function (name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = '; expires=' + date.toGMTString();
            } else {
                expires = '';
            }
            document.cookie =
                encodeURIComponent(name) +
                '=' +
                encodeURIComponent(value) +
                expires +
                '; path=/';
        },
        readCookie: function (name) {
            var nameEQ = encodeURIComponent(name) + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0)
                    return decodeURIComponent(
                        c.substring(nameEQ.length, c.length)
                    );
            }
            return null;
        },
        eraseCookie: function (name) {
            createCookie(name, '', -1);
        },
        appPost: function (info) {
            if (typeof info === 'string') {
                info = {pg: info, fields: {}};
            }
            if (info.fields) {
                var hasFile = false,
                    formData = info.fields;
            } else {
                if (info.formData) {
                    var hasFile = info.blobFiles && info.blobFiles.length,
                        formData = info.formData;
                } else {
                    var $form = info.$form,
                        hasFile =
                            $('[type="file"]', $form).length ||
                            (info.blobFiles && info.blobFiles.length),
                        $fields = $('[name]', $form),
                        formData = hasFile ? new FormData($form.get(0)) : {};
                }

                if (!hasFile && !info.formData) {
                    $fields.each(function (index) {
                        var field = $(this);
                        if (field.attr('type') == 'radio') {
                            if (field.is(':checked')) {
                                formData[field.attr('name')] = field.val();
                            }
                        } else {
                            formData[field.attr('name')] = field.val();
                        }
                    });
                } else if (info.blobFiles) {
                    // cropped/resized
                    for (var n = 0; n < info.blobFiles.length; n++) {
                        formData.append(
                            info.blobFiles[n].filename,
                            info.blobFiles[n].blob
                        );
                    }
                }
            }
            $.ajax({
                type: 'post',
                url: app_url + info.pg,
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    if (hasFile) {
                        xhr.upload.onprogress = function (evt) {
                            try {
                                if (info.$progressTag) {
                                    info.$progressTag.text(
                                        'Uploading... ' +
                                            Math.round(
                                                (evt.loaded / evt.total) * 100
                                            ) +
                                            '%'
                                    );
                                }
                            } catch (e) {}
                        };
                    }
                    return xhr;
                },
                crossDomain: true,
                dataType: 'html',
                xhrFields: {
                    withCredentials: true,
                },
                data: formData,
                success: function (data, status, res) {
                    if (!info.skip_success) {
                        myone.ajaxSuccess(data, res);
                    }
                    if (info.callback) {
                        try {
                            if (info.pass_data) {
                                info.callback(data);
                            } else {
                                info.callback();
                            }
                        } catch (e) {}
                    }
                },
                enctype:
                    hasFile || info.formData
                        ? 'multipart/form-data'
                        : 'application/x-www-form-urlencoded',
                contentType:
                    hasFile || info.formData
                        ? false
                        : 'application/x-www-form-urlencoded',
                processData: hasFile || info.formData ? false : true,
            });
        },
        updateLocationHash: function (page) {
            last_get_page = page;
            setTimeout(function () {
                last_get_page = false;
            }, 1000);
            location.hash = '#' + page;
        },
        locationHashChanged: function () {
            if (document.URL.indexOf('forgotpassword') == -1) {
                var page = location.hash.split('#')[1];
                if (page) {
                    myone.appGet(page, '#myonesubcontent');
                }
            }
        },
        triggerIntercoolerRequest: function (node) {
            if (node.data('elementAdded.ic')) {
                Intercooler.triggerRequest(node);
            } else {
                node.on('elementAdded.ic', function () {
                    Intercooler.triggerRequest(node);
                });
            }
        },
        appGet: function (page, area) {
            if (last_get_page && last_get_page == page) {
                return;
            }
            if (
                document.URL.indexOf('/pages/momentum') != -1 &&
                document.URL.indexOf('forgotpassword') == -1
            ) {
                var now = Date.now();
                if (now - last_hash_change < 500 && location.hash == page) {
                    return;
                }
                last_hash_change = Date.now();
                myone.updateLocationHash(page);
            }
            //this is temporary code to manage both intercooler and legacy myone_get requests
            //if this is a menu link then trigger via intercooler
            var menu_link = $('#myone_menu a[data-page="' + page + '"]');
            if (menu_link.length) {
                myone.triggerIntercoolerRequest(menu_link);
                return;
            }
            //otherwise make legacy ajax request
            var qs = '';
            if (qs_action) {
                qs = '?' + document.URL.split('?')[1].split('#')[0];
            }
            $.ajax({
                type: 'get',
                url: app_url + page + qs,
                crossDomain: true,
                dataType: 'html',
                xhrFields: {
                    withCredentials: true,
                },
                success: function (data, status, res) {
                    myone.ajaxSuccess(data, res, area);
                },
            });
            qs_action = false;
        },
        ajaxSuccess: function (data, res, area) {
            if (data === 'OK') {
                return;
            }
            //temporary intercooler integration so we can start using it for new functionality easily
            //the plan is to eventually replace myone_get() and myone_post() completely with intercooler
            //use $.parseHTML() instead of of $() otherwise html that doesn't start with <
            //gets treated as a selector
            var data_html = $.parseHTML(data, document, true);
            Intercooler.processNodes(data_html);

            var target = res.getResponseHeader('myone-target');
            if (!area && target && !$(target).length) {
                if (data.indexOf('script') !== -1) {
                    $('body').append(data);
                }
            } else {
                $(target || area || '#myonecontent')
                    .empty()
                    .html(data_html)
                    .css('height', 'auto');
            }
        },
        queryStringParamValue: function (key) {
            key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&'); // escape RegEx meta chars
            var match = location.search.match(
                new RegExp('[?&]' + key + '=([^&]+)(&|$)')
            );
            return match && myone.decodeURIComponent(match[1]);
        },
        toBase64: function (str) {
            return window.btoa(encodeURIComponent(str));
        },
        fromBase64: function (str) {
            return decodeURIComponent(window.atob(str));
        },
        decodeURIComponent: function (component) {
            return decodeURIComponent(component.replace(/\+/g, ' '));
        },
        queryStringToObject: function (query) {
            var params = {},
                match,
                search = /([^&=]+)=?([^&]*)/g;

            if (query.slice(0, 1) === '?') {
                query = query.slice(1);
            }
            while ((match = search.exec(query))) {
                params[
                    myone.decodeURIComponent(match[1])
                ] = myone.decodeURIComponent(match[2]);
            }
            return params;
        },
        setUrlParams: function (url, params) {
            var a = $('<a>', {href: url});
            var query = myone.queryStringToObject(a.prop('search'));
            var keys = Object.keys(params);
            for (var i = 0; i < keys.length; i++) {
                query[keys[i]] = params[keys[i]];
            }
            a.prop('search', '?' + $.param(query));
            return a.prop('href');
        },
        setUrlParam: function (url, name, value) {
            var params = {};
            params[name] = value;
            return myone.setUrlParams(url, params);
        },
        sendRedirect: function (url, params) {
            if (params) {
                url = myone.setUrlParams(url, params);
            }
            // the shopify theme editor (under online store > themes > customise)
            // doesn't like window.location to be used for redirects
            // so use window.top.location if it is accessible
            // which fails in the editor with a console error like
            // "A parameter or an operation is not supported by the underlying object"
            // but I think this is what shopify wants to happen within their editor
            var isTopAccessible = function () {
                try {
                    window.top.location;
                    return true;
                } catch (err) {
                    return false;
                }
            };
            if (isTopAccessible()) {
                window.top.location = url;
            } else {
                window.location = url;
            }
        },
        loadScript: function (path) {
            // jquery appends a cache buster to the script url
            // so explicitly turn that off by using $.ajax instead of $('body').append
            //$('body').append('<script src="'+app_url+path+'" async></script>');
            $.ajax({
                dataType: 'script',
                cache: true,
                url: app_url + path,
            });
        },
        loadInitScript: function () {
            // using crossorigin="use-credentials" doesn't help with safari login bug #240
            var path = 'scripts/init';
            var session = myone.getParameterByName('momentum_session');
            if (session) {
                path += '?session=' + session;
            }
            myone.loadScript(path);
        },
    };

    window.myone = myone;

    // legacy functions that need to be global
    // to be refactored and removed at some point
    // all new functions should be accessed via the myone object
    // to keep the global namespace clean
    window.getUrlVars = myone.getUrlVars;
    window.getParameterByName = myone.getParameterByName;
    window.createCookie = myone.createCookie;
    window.readCookie = myone.readCookie;
    window.eraseCookie = myone.eraseCookie;
    window.myone_post = myone.appPost;
    window.myone_get = myone.appGet;
    window.myone_ajax_success = myone.ajaxSuccess;
    // note misspelled function name
    window.queryStingParamValue = myone.queryStringParamValue;
    window.locationHashChanged = myone.locationHashChanged;
    window.toBase64 = myone.toBase64;
    window.fromBase64 = myone.fromBase64;
})();
